import React from 'react';
import { clsx } from '../../../../utils/clsx';
import { dlDispatchAmplEvent } from '../../../../events/dl.dispatchAmplEvent';
export const ArtworkButton = ({ active, toggleActiveFunction }) => {
    return (React.createElement("button", { className: "btn:cleared bg:white fz:10 fz:14:xl-up lts:001 fw:700 h:28 h:36:xl-up pos:a b:14 b:20:xl-up r:14 r:56:lg-up r:64:xl-up z:2 pr:16 pl:6 d:flex ai:center jc:center bxsh:2 bdrs:24 trs trs:all trs:du:300", onClick: () => {
            toggleActiveFunction();
            !active && dlDispatchAmplEvent('Square image view');
        } },
        React.createElement("span", { className: clsx('trs trs:all trs:du:300 p:2 p:4:xl-up mr:8 bd bd:w:1 bd:c:text bdrs:18', active && 'bg:color-text') },
            React.createElement("i", { className: clsx('d:block bdrs:50p h:10 h:12:xl-up w:10 w:12:xl-up trs trs:all trs:du:300', !active
                    ? 'bg:color-text mr:14 mr:16:xl-up ml:0'
                    : 'bg:white mr:0 ml:14 ml:16:xl-up') })),
        React.createElement("span", null, "ZOOM")));
};
